var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgProgressDone = function SvgProgressDone(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 21 20",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#svg_icon_progress_done__clip0_2363_7165)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10,
    r: 10,
    fill: "#4DFFB4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M8.75 12.888 5.162 9.3l-1.224 1.225 3.587 3.588 1.225 1.225L17.587 6.5l-1.224-1.312z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "svg_icon_progress_done__clip0_2363_7165"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    x: 0.5,
    fill: "#fff",
    rx: 10
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgProgressDone);
export { ForwardRef as ReactComponent };